export const dustLimit = 546;

export type NetworkType = "testnet" | "mainnet";

export const LOWEST_POSSIBLE_ONCHAIN_FEE_SATS = 1000;
export const MIN_CHANNEL_SIZE_SATS = 150_000;
export const EACH_CLOSURE_MIGHT_COST = 70_000;
// a higher number and LND will error instead of getting fees
export const TEST_CHANNEL_OPENS_WITH_THIS_SATOSHIS = 10_000;

// to do should be dynamic based on current fees
export const UNDER_THIS_AMOUNT_MUST_USE_SEND_ALL = 25_000;

export const DEFAULT_PATH_FIND_TIMEOUT_IN_SECONDS = 60;

export const MODAL_WIDTH_FOR_DATA_INTENSIVE_MODALS = "95%";

export const MODALS = {
  CHANGE_ALIAS: "change-alias",
  NODE_INFO: "node-info",
  NODE_PEERS: "node-peers",
  USER_SETTINGS: "user-settings",
  DESTROY_CUBBY: "destroy-cubby",
  SHOW_PEERS: "show-peers",
  DEPOSIT_BTC: "deposit-btc",
  SEND_BTC: "send-btc",
  CONNECT_TO_OTHER_NODE: "connect-to-other-node",
  OPEN_CHANNEL_TO_OTHER_NODE: "open-channel-to-other-node",
  NODE_IDENTITY: "node-identity",
  SEND_LIGHTNING: "send-lightning",
  SEND_VIA_BOLT_11_INVOICE: "send-via-bolt-11-invoice",
  SEND_VIA_KEYSEND: "send-via-keysend",
  CREATE_INVOICE: "create-invoice",
  LIGHTNING_OUTBOUND_EVENTS: "lightning-outbound-events",
  LIGHTNING_INBOUND_EVENTS: "lightning-inbound-events",
  BITCOIN_WITHDRAWAL_EVENTS: "bitcoin-withdrawal-events",
  CUBBY_ERRORS: "cubby-errors",
  BITCOIN_ONCHAIN_TRANSACTIONS: "bitcoin-onchain-transactions",
  GET_INBOUND: "get-inbound",
  CLOSED_CHANNELS: "closed-channels",
  MANAGE_UPTIME: "manage-uptime",
  RECEIVE_LIGHTNING: "receive-lightning",
  MANAGE_LIGHTNING_ADDRESS: "manage-lightning-address",
  PAY_TO_LIGHTNING_ADDRESS: "pay-to-lightning-address",
  CONFIRM_PAY_TO_LIGHTNING_ADDRESS: "confirm-pay-to-lightning-address",
  SIGN_MESSAGE: "sign-message",
  CONNECT_APPS: "connect-apps",
  SINGLE_NOSTR_CONNECTION: "single-nostr-connection",
};
